// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lottery-container[data-v-0dceebed] {\n  width: 100%;\n}\n.lottery-container .marginBottom[data-v-0dceebed] {\n  margin-bottom: 25px;\n}", ""]);
// Exports
module.exports = exports;
